<template>
  <router-view v-if="!loading" />
</template>

<script>
import { previewLogin } from '@/api/user'
export default {
  data () {
    return {
      loading: true
    }
  },
  async created () {
    const loadingInstant = this.$loading({
      lock: true,
      text: '加载中...即将打开新世界的大门',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)'
    })
    const res = await previewLogin('website')
    if (res && res.data.success) {
      window.XBB_MODULE_CENTER_TYPE = 'preview'
      localStorage.setItem('token', res.data.result.token)
      localStorage.setItem('shelf_version', 1) // 预览设置成钉钉版
    }
    this.loading = false
    loadingInstant.close()
  }
}
</script>
<style lang="scss">
.icon {
  width: 1.5em; height: 1.5em;
  vertical-align: -0.4em;
  fill: currentColor;
  overflow: hidden;
  display: inline-block;
}
</style>
